module.exports = __webpack_public_path__ + "img/uk.6ef59119.svg";